import { TFunction } from 'i18next'

import { BadgeColorKeys } from '@/components/ui/badge'

const STATUS_COLOR_MAP: Record<string, BadgeColorKeys> = {
  expired: 'red',
  'not-redeemed': 'blue',
  redeemed: 'green',
}

export const getGiftCardStatusColor = (status: string): BadgeColorKeys =>
  STATUS_COLOR_MAP[status] ?? 'neutral'

export const getGiftCardStatusLabel = (status: string, t: TFunction<['gift-cards']>): string => {
  const labels: Record<string, string> = {
    expired: t('gift-cards:statuses.expired'),
    'not-redeemed': t('gift-cards:statuses.notRedeemed'),
    redeemed: t('gift-cards:statuses.redeemed'),
  }
  return labels[status] ?? status
}

export const getGiftCardCategoryLabel = (
  category: string,
  t: TFunction<['gift-cards']>,
): string => {
  const labels: Record<string, string> = {
    maintenanceIssue: t('gift-cards:categories.maintenanceIssue'),
    moveIn: t('gift-cards:categories.moveIn'),
    other: t('gift-cards:categories.other'),
    referral: t('gift-cards:categories.referral'),
    renewal: t('gift-cards:categories.renewal'),
  }
  return labels[category] ?? category
}
